/**
 * ======= Module =======
 */
export default {
  debug(message) {
    const isProd = process.env.NODE_ENV === 'production';

    // eslint-disable-next-line
    if (!isProd) console.log(message);
  },

  error(message) {
    const isProd = process.env.NODE_ENV === 'production';

    // eslint-disable-next-line
    if (!isProd) console.error(message);
  },
};
